export default "__VITE_ASSET__31b6ce53__"